import api from './api';

export const getSupportCategories = async () => {
  const res = await api.get('/support/categories');
  return res.data; // { categories }
};

export const getSupportQuestions = async (categoryId) => {
  const res = await api.get(`/support/categories/${categoryId}/questions`);
  return res.data; // { questions }
};

export const getSupportQuestion = async (questionId) => {
  const res = await api.get(`/support/questions/${questionId}`);
  return res.data; // { question }
};

export const sendQuestionFeedback = async (questionId, payload) => {
  // payload: { helpful }
  const res = await api.post(`/support/questions/${questionId}/feedback`, payload);
  return res.data;
};

export const escalateToTicket = async (payload) => {
  // payload: { questionId, message }
  const res = await api.post('/support/escalate', payload);
  return res.data;
};